import React from "react"
import { Card, CardBody, CardHeader } from "reactstrap"
import { ExpenseMonthlyDueDatesListContainer } from "components/expenseMonthlyDueDates/redux/ExpenseMonthlyDueDatesContainers"
import Icon from "components/common/Icon"

const ExpenseMonthlyDueDatesCardBasic = () => {
    return (
        <Card>
            <CardHeader>
                <h6>
                    <Icon calendar/>
                    Expense Monthly Due Dates
                </h6>
            </CardHeader>
            <CardBody>
                <ExpenseMonthlyDueDatesListContainer />
            </CardBody>
        </Card >
    )
}

export default ExpenseMonthlyDueDatesCardBasic